export const appNameValidator = value => {
	if (!value) {
		return 'Everything has a name.'
	} else if (value.length > 30) {
		return 'Sorry, the name must be 30 characters or less.'
	} else if (value.length < 2) {
		return 'Apologies, the name must be at least 2 characters long.'
	}
	return undefined
}

export const appDeleteValidator = value => {
	if (value !== 'DELETE') {
		return 'Please write "DELETE" if you really want to delete this app.'
	}
	return undefined
}

export const appShortDescValidator = value => {
	if (!value) {
		return 'Woops! Sorry, we need some decription.'
	} else if (value.length > 120) {
		return "Sorry, we're limited here to 120 letters."
	}
	return undefined
}

export const appDescValidator = value => {
	if (!value) {
		return 'Apologies, the description is required.'
	} else if (value.length < 32) {
		return "Sorry, we'd love to hear a bit more on your app. Please use at least 32 characters."
	}
	return undefined
}

export const appIconValidator = value => {
	if (!value) {
		return 'Apologies, icon is required! You can use the icon generator above.'
	}
	return undefined
}

export const webhookUrlValidator = value => {
	let r = /^(http)(s)?:\/\/[^ "]+$/

	if (r.test(value) === false) {
		return 'Ooops! We need a valid URL.'
	}

	return undefined
}

export const appTutorialUrlValidator = value => {
	let r = /^(http)(s)?:\/\/[^ "]+$/

	if (value !== '' && r.test(value) === false) {
		return 'Ooops! We need an URL that starts with http(s)://...'
	}

	return undefined
}

export const extensionUrlValidator = value => {
	let r =
		process.env.REACT_APP_ENV === 'prod'
			? /^(https):\/\/[^ "]+$/
			: /^(http)(s)?:\/\/[^ "]+$/

	if (!value) {
		return 'We need to know where your extension lives.'
	} else if (r.test(value) === false) {
		return 'Ooops! We need an URL that starts with https://...'
	}

	return undefined
}



// WEBPACK FOOTER //
// ./src/containers/Forms/validators.js